module.exports = __webpack_public_path__ + "img/86c67b6.jpg";